import { Record } from 'immutable';

export const mkShare = Record({
  id: undefined,
  clientId: undefined,

  datasetId: undefined,

  granteeFirstName: undefined,
  granteeLastName: undefined,
  granteeEmail: undefined,

  grantorFirstName: undefined,
  grantorLastName: undefined,
  grantorEmail: undefined,

  permissions: '0',
  state: undefined,

  lastAccessedAt: undefined,

  testMode: false,

  createdAt: undefined,
  isDeleted: undefined,
});
